module.exports = __webpack_public_path__ + "static/img/pagi-large.e40c92e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/pagi-large.png
// module id = Lhm+
// module chunks = 6